<div class="row">
  <div class="col-lg-5 col-sm-12 col-xs-12">
    <kla-title [lineConfig]="lineConfig" [config]="config.title"></kla-title>
  </div>
  <div class="col-lg-7 col-sm-12 col-xs-12 chart" #panel>
    <kla-bar-chart [width]="width" [height]="height" [config]="config.barChart"
      [attr.role]="config.chartAltText ? 'img' : null"
      [attr.aria-label]="config.chartAltText || null"
      [attr.aria-hidden]="config.chartAltText ? null : 'true'"></kla-bar-chart>
  </div>
</div>
<div class="bar-graph-news row">
  <div class="col-lg-6" *ngFor="let config of listOfNews">
    <kla-news [config]="config"></kla-news>
  </div>
</div>
